import { render } from "./LoanBanner.vue?vue&type=template&id=14170435"
import script from "./LoanBanner.vue?vue&type=script&lang=js"
export * from "./LoanBanner.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__